import React from 'react';
import {LeftOutlined, RightOutlined} from "@ant-design/icons";
export const getAccessibleItemRender = ({ currentPage, totalResults, pageSize, showOnePageTotal }) => {
    return (page, type, originalElement) => {
        if (showOnePageTotal) return null;
        const handleButtonKeyDown = (e) => {
            if (e.key === 'Enter' || e.key === ' ') e.stopPropagation();
        };
        if (type === 'prev') {
            const isPrevDisabled = currentPage <= 1;
            return (
                <button
                    type="button"
                    className="ant-pagination-item-link"
                    aria-label="Previous Page"
                    disabled={isPrevDisabled}
                    onKeyDown={handleButtonKeyDown}
                >
                    <LeftOutlined />
                </button>
            );
        }

        if (type === 'next') {
            const totalPages = Math.ceil(totalResults / pageSize);
            const isNextDisabled = currentPage >= totalPages;
            return (
                <button
                    type="button"
                    className="ant-pagination-item-link"
                    aria-label="Next Page"
                    disabled={isNextDisabled}
                    onKeyDown={handleButtonKeyDown}
                >
                    <RightOutlined />
                </button>
            );
        }

        if (type === 'page') {
            const isSelected = currentPage === page;
            return (
                <button
                    type="button"
                    className={`link-button ${isSelected ? 'active-page-style-class' : ''}`}
                    aria-label={`Page ${page}`}
                    aria-current={isSelected ? 'page' : undefined}
                    onKeyDown={handleButtonKeyDown}
                >
                    {page}
                </button>
            );
        }
        return originalElement;
    };
};